import { FC, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import useUser from "../../../hooks/useUser";

import './LogoutAlert.css';

interface AlertModalProps {
    visible: boolean;
    setVisible: (visible: boolean) => void;
}

const LogoutAlert: FC<AlertModalProps> = ({ visible, setVisible }) => {
    const user = useUser();
    const navigate = useNavigate();
    const logoutAlertRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (visible) {
            const handleClickOutside = (event: MouseEvent) => {
                if (logoutAlertRef.current && !logoutAlertRef.current.contains(event.target as Node)) {
                    setVisible(false);
                }
            };

            document.addEventListener('mousedown', handleClickOutside);

            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
    }, [visible, setVisible]);

    const handleLogout = () => {
        user.logout();
        navigate('/');
        setVisible(false);
    };

    return (
        <div className={`LogoutAlertContent ${visible ? 'active' : ''}`} ref={logoutAlertRef}>
            <h3>Вы точно хотите выйти из аккаунта?</h3>
            <div>
                <button onClick={handleLogout}>Да</button>
                <button onClick={() => setVisible(false)}>Нет</button>
            </div>
        </div>
    );
};

export default LogoutAlert;
